import React, { useEffect } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store/index";
import { useAccount, useSwitchChain, WagmiProvider } from "wagmi";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { wagmiConfig } from "./wagmiConfig";
import { EventSessionProvider } from "./contexts/EventSessionContext.js";
import { sepolia } from "viem/chains";


function NetworkValidator() {
  const { isConnected, chainId } = useAccount();
  const { switchChainAsync } = useSwitchChain();
  const CHAIN_ID = Number(process.env.REACT_APP_CHAIN_ID) || 11155111;

  useEffect(() => {
    if (isConnected && chainId && chainId !== CHAIN_ID && switchChainAsync) {
      switchChainAsync({ chainId: CHAIN_ID }).catch((error) => {
        if (error?.code !== 4001) {
          console.log("Failed to switch network:", error);
        }
      });
    }
  }, [isConnected, chainId, switchChainAsync]);

  return null;
}

const queryClient = new QueryClient();
const domNode = document.getElementById("root");
const root = createRoot(domNode);


root.render(
  <Provider store={store}>
    <EventSessionProvider>
      <WagmiProvider config={wagmiConfig}>
        <QueryClientProvider client={queryClient}>
          <NetworkValidator />
          <App />
        </QueryClientProvider>
      </WagmiProvider>
    </EventSessionProvider>
  </Provider>
);
